import LegalHero from "../LegalHero";
import "../LegalProse.css";

import SeoHead from "../../../../seo/SeoHead";
import {
  PRIVACY_PAGE_DESCRIPTION,
  PRIVACY_PAGE_TITLE,
} from "../../../../seo/siteConfig";

function PrivacyPolicy() {
  return (
    <div>
      <SeoHead
        title={PRIVACY_PAGE_TITLE}
        description={PRIVACY_PAGE_DESCRIPTION}
        path="/privacy-policy"
      />
      <LegalHero
        title="Privacy Policy"
        subtitle="How we handle information when you use SERVED."
      />
      <article className="legal-prose">
        <p className="legal-meta">Last updated: March 2026.</p>

        <section>
          <h2>Introduction</h2>
          <p>
            Served Ltd. (“SERVED”, “we”, “us”) respects your privacy. This
            policy describes the types of information we may collect, how we use
            it, and the choices available to you. It is provided as a template
            only and does not constitute legal advice.
          </p>
        </section>

        <section>
          <h2>Information we may collect</h2>
          <p>
            Depending on how you interact with us, we may process categories
            such as:
          </p>
          <ul>
            <li>
              Contact and account details you submit (for example name, email,
              business information).
            </li>
            <li>
              Content and materials you provide for protection services, where
              applicable to delivering the service you request.
            </li>
            <li>
              Technical data from your visit to our website (for example device
              type, browser, approximate region, and pages viewed).
            </li>
          </ul>
        </section>

        <section>
          <h2>How we use information</h2>
          <p>We may use information to:</p>
          <ul>
            <li>Provide, operate, and improve our services and website.</li>
            <li>Respond to enquiries and communicate about your account.</li>
            <li>Comply with legal obligations and enforce our terms.</li>
            <li>Analyse usage in aggregate to improve security and UX.</li>
          </ul>
        </section>

        <section>
          <h2>Cookies and similar technologies</h2>
          <p>
            We may use cookies, local storage, and similar technologies to
            remember preferences, measure traffic, and keep the site secure. You
            can control cookies through your browser settings. See this policy
            and your browser help for details.
          </p>
        </section>

        <section>
          <h2>Retention and security</h2>
          <p>
            We retain information only as long as needed for the purposes above
            or as required by law. We implement appropriate technical and
            organisational measures designed to protect personal data; no method
            of transmission over the internet is completely secure.
          </p>
        </section>

        <section>
          <h2>Your rights</h2>
          <p>
            Depending on where you live, you may have rights to access, correct,
            delete, or restrict certain processing of your personal data, and to
            object or lodge a complaint with a supervisory authority. Contact us
            using the details below to exercise applicable rights.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            For privacy-related questions, contact Served Ltd. through the
            contact options provided on this website. Update this section with
            your official address and contact channels.
          </p>
        </section>
      </article>
    </div>
  );
}

export default PrivacyPolicy;
